/* eslint-disable */
import '../../globalStyle.scss'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import PersonInfo from './PersonInfo'
import { fetchClient } from '../../apiCalls/alertsApi'
import { useApiGet } from '../../apiCalls/useApi'
import InvestigationContent from './InvestigationContent'
import { OrgAppContext } from '../../OrgAppContext'

export default function ClientInvestigation() {
  const { appId } = useContext(OrgAppContext)
  const location = useLocation()
  const { searchID } = location.state || {}
  const [personInfo, setPersonInfo] = useState({
    orgId: '',
    appId: '',
    id: '',
    name: '',
    service: '',
    firstAccessTime: '',
    lastAccessTime: '',
  })
  const [isPersonInfoLoading, setIsPersonInfoLoading] = useState<boolean>(false)
  const getPersonInfo = useApiGet(fetchClient)

  useEffect(() => {
    if (searchID) {
      setIsPersonInfoLoading(true)
      getPersonInfo({
        appId,
        clientId: searchID,
      }).then((res: any) => {
        if (res && res.data && !res.error) {
          setPersonInfo(res.data)
          setIsPersonInfoLoading(false)
        }
      })
    }
  }, [searchID])

  return (
    <div className='investigationContent'>
      <PersonInfo info={personInfo} isLoading={isPersonInfoLoading} type='Client' />
      <InvestigationContent type='Client' searchID={searchID} />
    </div>
  )
}
